import pagination from "./pagination";
import pageActions from "./pageActions";
import addPagesActions from "./addPagesActions";
import pageHierarchyActions from "./pageHierarchyActions";
import pageSeoActions from "./pageSeoActions";
import templateActions from "./templateActions";
import visiblePanelActions from "./visiblePanelActions";
import visiblePageSettingsActions from "./visiblePageSettingsActions";
import languagesActions from "./languagesActions";

export {
    pagination,
    pageActions,
    addPagesActions,
    pageHierarchyActions,
    pageSeoActions,
    templateActions,
    visiblePanelActions,
    visiblePageSettingsActions,
    languagesActions
};
